export default "<div class=\"chart-area mt-5 \" style=\"height: 200px\"><canvas id=\"headerChart\"></canvas></div>";